import React from "react";
import { useTranslation } from "react-i18next";
import { Check, Minus } from "lucide-react";
import { dateLocale } from "i18n";

export const formatDate = (
  iso,
  opts = { day: "numeric", month: "short", year: "numeric" }
) => (iso ? new Date(iso).toLocaleDateString(dateLocale("en-GB"), opts) : "");

export const Tick = ({ on, label }) => (
  <span
    title={label}
    aria-label={label}
    className={`inline-flex h-6 w-6 items-center justify-center rounded-full ${
      on ? "bg-[#ECFDF5] text-[#047857]" : "bg-[#F3F4F6] text-[#9CA3AF]"
    }`}
  >
    {on ? <Check size={14} strokeWidth={3} /> : <Minus size={14} />}
  </span>
);

/** "Consented", "Awaiting consent", "Withdrawn · deleted 22 Nov", "Legal hold". */
export const ConsentStatusBadge = ({ player }) => {
  const { t } = useTranslation();
  if (player.legal_hold) {
    return (
      <span className="rounded-md bg-[#EEF2FF] px-2 py-0.5 text-xs font-semibold text-[#4338CA]">
        {t("team.consentTab.status.legalHold")}
      </span>
    );
  }
  const styles = {
    granted: "bg-[#ECFDF5] text-[#047857]",
    awaiting: "bg-[#FEF3C7] text-[#92400E]",
    withdrawn: "bg-[#FEF2F2] text-[#B91C1C]",
    not_required: "bg-[#F3F4F6] text-[#6B7280]",
  };
  let label = t(`team.consentTab.status.${player.consent_status}`);
  if (player.deletion_scheduled_for) {
    label = t("team.consentTab.status.deletionScheduled", {
      status: label,
      date: formatDate(player.deletion_scheduled_for, {
        day: "numeric",
        month: "short",
      }),
    });
  }
  return (
    <span
      className={`whitespace-nowrap rounded-md px-2 py-0.5 text-xs font-semibold ${
        styles[player.consent_status] || styles.not_required
      }`}
    >
      {label}
    </span>
  );
};
